import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';
import SectionTitle from '../../section-title/section-title.component';

const GiftCardDetails = ({ giftCardNumber, currentCardBalance, currency }) => {
  const { t } = useTranslation();

  const giftCardBreakdown = [
    {
      value: giftCardNumber,
      description: t('drawer.refundDrawer.giftCardDetails.giftCardNumber'),
    },
    {
      value: formatCurrency(currentCardBalance, currency),
      description: t('drawer.refundDrawer.giftCardDetails.currentCardBalance'),
    },
  ];

  return (
    <Box>
      <SectionTitle title={t('drawer.refundDrawer.giftCardDetails.title')} />
      <Stack spacing={1}>
        {giftCardBreakdown.map(({ value, description }, index) => (
          <Box display="flex" justifyContent="space-between" key={index}>
            <Typography sx={{ fontWeight: 'bold' }}>{description}</Typography>
            <Typography sx={{ fontWeight: 'bold' }}>{value}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default GiftCardDetails;
